import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/apiClient';

type RequestState = 'idle' | 'loading' | 'success' | 'error';

const safeSuccessMessage =
  'If an account exists for that email, a password reset link will be sent.';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [requestState, setRequestState] = useState<RequestState>('idle');

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setRequestState('loading');

    try {
      await api<{ ok: true; message: string }>('/api/auth/password-reset/request', {
        method: 'POST',
        body: JSON.stringify({ email })
      });
      setRequestState('success');
    } catch {
      setRequestState('error');
    }
  }

  return (
    <section className="container-shell flex min-h-[75vh] items-center justify-center py-16">
      <form onSubmit={onSubmit} className="glass w-full max-w-md rounded-3xl p-8" autoComplete="off">
        <div className="text-center">
          <h1 className="text-3xl font-black">Reset Password</h1>
          <p className="mt-4 text-sm leading-6 text-white/60">
            Enter your PrimeTime DJ Pool account email and we will send reset instructions if the account exists.
          </p>
        </div>

        {requestState === 'success' && (
          <div className="mt-5 rounded-xl border border-emerald-400/40 bg-emerald-400/10 p-3 text-sm text-emerald-100">
            {safeSuccessMessage}
          </div>
        )}

        {requestState === 'error' && (
          <div className="mt-5 rounded-xl border border-prime-red/40 bg-prime-red/10 p-3 text-sm text-red-200">
            We could not process the request right now. Please try again.
          </div>
        )}

        <label className="mt-6 block text-sm font-bold text-white/70">Email</label>
        <input
          className="form-input mt-2"
          type="email"
          value={email}
          autoComplete="email"
          required
          onChange={(event) => setEmail(event.target.value)}
        />

        <button className="btn-primary mt-6 w-full" type="submit" disabled={requestState === 'loading'}>
          {requestState === 'loading' ? 'Sending...' : 'Send Reset Link'}
        </button>

        <div className="mt-6 text-center text-sm text-white/55">
          <Link to="/login" className="text-prime-red hover:underline">
            Back to sign in
          </Link>
        </div>
      </form>
    </section>
  );
}
